import React from 'react';
import YesNoQuestion from '../../../ui/advisory-flow/components/shared-components/YesNoQuestion';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { useFlowsProgression } from '../../../../hooks/useFlowsProgression';

interface Props {
  question: FlowsQuestion;
}

const SingleCheckboxInputComponent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question }) => {
  const {
    field: { onBlur, value },
  } = useFlowInputComponent({ question });
  const { nextQuestion } = useFlowsProgression();
  const handleYes = () => {
    onBlur({ name: question.id, value: true });
    nextQuestion();
  };

  const handleNo = () => {
    onBlur({ name: question.id, value: false });
    nextQuestion();
  };

  return (
    <YesNoQuestion
      handleYes={handleYes}
      handleNo={handleNo}
      defaultValue={value as boolean | undefined}
    />
  );
};

export default SingleCheckboxInputComponent;
